import React, { useEffect, useState } from "react";
import { IUserData } from "../../../interfaces/userData.interface";
import { IDepartmentStaffMapping } from "../../../interfaces/department.interface";
import departmentConfigscss from "../../../sass/department/DepartmentListConfig.module.scss";
import { Collapse, Form } from "react-bootstrap";
import { appAxios } from "../../../axios/axios";
import { toast } from "react-toastify";
import { LoadingOverlay } from "../../Common/Ui/LoadingOverlay";
import { Link } from "react-router-dom";

export const StaffDepartmentList: React.FC<{
  staff: IUserData & {
    departmentStaffMapping: IDepartmentStaffMapping[];
  };
  index: number;
}> = (props) => {
  const [selectedPrimaryDepartment, setSelectedPrimaryDepartment] =
    React.useState<IDepartmentStaffMapping | null>(null);

  const [selectedLoading, setSelectedLoading] = React.useState<{
    [key: number]: boolean;
  }>({});

  const [openPrimaryDepartmentCollapse, setOpenPrimaryDepartmentCollapse] =
    useState<boolean[]>([]);
  const handleChange = async (
    departmentMapping: IDepartmentStaffMapping,
    index
  ) => {
    try {
      setSelectedLoading((prevState) => ({
        [index]: true,
      }));
      setSelectedPrimaryDepartment(null);
      const updateResponse = await appAxios.post(
        "/query-management-staff/updatePrimaryDepartment",
        {
          staffUUId: props.staff.uuid,
          departmentId: departmentMapping.department.id,
        }
      );

      if (updateResponse.data.success) {
        setSelectedPrimaryDepartment(departmentMapping);
        toast.success("Primary Department Updated");
      }
      setSelectedLoading((prevState) => ({
        [index]: false,
      }));
    } catch (error: any) {
      toast.error(error.data.errorMessage || "Something went wrong");
      setSelectedLoading((prevState) => ({
        [index]: false,
      }));
    }
  };

  useEffect(() => {
    const primaryDepartment = props.staff.departmentStaffMapping.find(
      (department) => department.isPrimary
    );
    setSelectedPrimaryDepartment(primaryDepartment || null);
  }, [props.staff]);

  return (
    <>
      <div
        className={`${departmentConfigscss.staffDepartmentListConfig} border shadow-sm rounded my-2 p-3`}
      >
        <div className="row small">
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div>
              <span className="text-secondary"> Staff Name : </span>{" "}
              {props.staff.firstName + "" + props.staff.lastName}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div>
              <span className="text-secondary"> Phone : </span>{" "}
              {props.staff.phoneNumbers.find(
                (phone) => phone.label === "Primary"
              )?.phoneNumber || "Not found"}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div>
              <span className="text-secondary"> Primary Department :</span>{" "}
              {selectedPrimaryDepartment?.department.departmentName ||
                "Not Selected"}
            </div>
          </div>
        </div>

        <div
          className="small bg-light mt-3 px-3 py-2"
          onClick={() =>
            setOpenPrimaryDepartmentCollapse((old) => {
              old[props.index] = !old[props.index];
              return [...old];
            })
          }
        >
          Change Primary Department{" "}
          <i className="fa-solid fa-angle-down ms-2"></i>
        </div>
        <div className={departmentConfigscss.selectDepartmentList}>
          <Collapse in={openPrimaryDepartmentCollapse[props.index]}>
            <div>
              <div className="row">
                {props.staff.departmentStaffMapping.length ? (
                  props.staff.departmentStaffMapping.map(
                    (departmentMapping, index) => {
                      return (
                        <div className="col-lg-3 position-relative" key={index}>
                          {selectedLoading[index] && <LoadingOverlay />}
                          <Form.Check
                            className="w-100 d-flex align-items-center border my-2 rounded"
                            inline
                            label={departmentMapping.department.departmentName}
                            name={`${props.staff.uuid}`}
                            type={"radio"}
                            id={`${props.staff.uuid}-${index}`}
                            onChange={() => {
                              handleChange(departmentMapping, index);
                            }}
                            checked={
                              selectedPrimaryDepartment?.id ===
                              departmentMapping.id
                            }
                          />
                        </div>
                      );
                    }
                  )
                ) : (
                  <span className="text-danger small">Not Assigned </span>
                )}
              </div>
              <p className="text-muted" style={{ fontSize: "13px" }}>
                Staff is assigned to different departments shown above. If you
                want to assign staff member to more departments (
                <Link to={"/department"}>Add Department</Link>)
              </p>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};
